import { createContext, useContext } from 'react';
import { BdmHoldPolicyListItem } from '../../../types/opm-pd-bdm-types';

type FormPolicy = BdmHoldPolicyListItem & {
  _index: number;
  _selectedOtherQualifiedAgent: {
    agentCode: string;
    fullname: string;
    label: string;
  } | null;
  _displaySelectedAgent: string;
  _displaySelectedAgentName: string;
  _selectedOtherAgentReason: string;
  _isDeleted: boolean;
};

export type ReassignAgentForHoldPoliciesContextType = {
  bdmHoldPolicies: BdmHoldPolicyListItem[];
  bdmHoldPoliciesLoading: boolean;
  formPolicies: FormPolicy[];
  isSubmitting: boolean;
  submitBdmHoldPolicies: () => Promise<void>;
  setPolicyFieldValue: (index: number, field: keyof FormPolicy, value: any) => void;
  addOtherQualifiedAgentToPolicy: (
    qualifiedAgents: { agentCode: string; fullname: string; label: string; policyNumbers: string[] }[],
  ) => void;
  removeFormPolicy: (index: number | number[]) => void;
};

export const ReassignAgentForHoldPoliciesContext = createContext<ReassignAgentForHoldPoliciesContextType>({
  bdmHoldPolicies: [],
  bdmHoldPoliciesLoading: false,
  formPolicies: [],
  isSubmitting: false,
  submitBdmHoldPolicies: async () => {},
  setPolicyFieldValue: () => {},
  addOtherQualifiedAgentToPolicy: () => {},
  removeFormPolicy: () => {},
});

export const useReassignAgentForHoldPoliciesContext = (): ReassignAgentForHoldPoliciesContextType => {
  const context = useContext(ReassignAgentForHoldPoliciesContext);
  if (!context) {
    throw new Error(
      'useReassignAgentForHoldPoliciesContext must be used within a ReassignAgentForHoldPoliciesContext.Provider',
    );
  }
  return context;
};
